module.exports = __webpack_public_path__ + "static/media/agent11.ecdd2c4a.png";